<template>
    <form action="" @submit.prevent="onNotificationFormSubmit">
        <h2 class="h6 mb-4">Powiadomienia o dokumentach rozliczeniowych</h2>
        <the-input
            required
            id="billing-management-email"
            class="cux-exclude mb-4"
            type="email"
            :label="'E-mail'"
            name="billing-management-email"
            :text="notificationEmail"
            @input="onNotificationEmailInput"
        ></the-input>
        <div>
            <radio-input
                required
                id="billing-notification-radio-0"
                :data="{
                    label: 'Nie wysyłaj informacji o dokumentach',
                    value: 'DO_NOT_SEND_INFO'
                }"
                name="billing-management-notification"
                :value="notificationState"
                @change="onBillingNotificationChange"
            />

            <radio-input
                id="billing-notification-radio-1"
                :data="{
                    label:
                        'Wysyłaj powiadomienia o nowych dokumentach na podany adres',
                    value: 'SEND_NOTIFICATIONS'
                }"
                name="billing-management-notification"
                :value="notificationState"
                @change="onBillingNotificationChange"
            />
        </div>
        <div>
            <the-btn
                id="login"
                :btnClass="'mt-4 text-white btn-block btn-secondary'"
                :text="'Zapisz zmiany'"
            ></the-btn>
        </div>
    </form>
</template>

<script>
export default {
    name: 'BillingDocumentsManagement',
    computed: {
        userData() {
            return this.$store.getters.getUser
        }
    },
    beforeMount() {
        this.setNotificationData()
    },
    data() {
        return {
            notificationEmail: '',
            notificationState: 'DO_NOT_SEND_INFO'
        }
    },
    methods: {
        onNotificationEmailInput(text) {
            this.notificationEmail = text
        },
        onNotificationFormSubmit() {
            this.$store.dispatch('setUserBillingNotifications', {
                sendNotifications: this.notificationState,
                email: this.notificationEmail
            }).then(() => {
                this.setNotificationData()
            })
        },
        onBillingNotificationChange(state) {
            this.notificationState = state
        },
        setNotificationData() {
            this.notificationEmail = this.userData.notificationEmail || this.userData.email
            this.notificationState = this.userData.sendNotificationsStatus
        }
    }
}
</script>
